<div class="header-container">
  <div class="header-text">
    <span class="header-welcome">Welcome to</span>
    <span class="header-title">Clinical Decision Suite</span>
    <span class="header-subtitle"
      >Unifying data, insight & collaboration across clinical development</span
    >
    <span class="header-product">A PPD product</span>
  </div>
  <div class="header-data">
    <div class="header-data-section">
      <div class="header-data-item">
        <span class="header-subtitle">Active studies</span>
      </div>
      <div>
        <span class="header-text-data-number" *ngIf="!isLoading">{{ activeStudiesCount }}</span>
        <span class="header-text-data-number" *ngIf="isLoading">--</span>
        <mat-icon svgIcon="growth-chart" class="header-chart-icon"></mat-icon>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="header-data-section">
      <div class="header-data-item">
        <span class="header-text-data" *ngIf="!isLoading">{{ countriesCount }}</span>
        <span class="header-text-data" *ngIf="isLoading">--</span>
        <span class="header-text-data">Countries</span>
      </div>
      <div class="header-data-item">
        <span class="header-text-data" *ngIf="!isLoading">{{
          subjectsEnrolledCount | number
        }}</span>
        <span class="header-text-data" *ngIf="isLoading">--</span>
        <span class="header-text-data">Subjects enrolled</span>
      </div>
    </div>
  </div>
</div>
